module.exports = __webpack_public_path__ + "media/images/markitup/actions-9ad228c359d71a07084e657752f90dd8.png";